import { GridColDef } from "@mui/x-data-grid-pro";
import {
  Box,
  Edit1Icon,
  GKButton,
  GKDataGrid,
  IconButton,
  PlusIcon,
  SettingsIcon,
  Typography,
} from "components";
import useGenerateQueryParams from "hooks/useGenerateQueryParams";
import { useFetchQuery } from "hooks/useQueries";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { GET_ALL_EMPLOYEE_LIST } from "utils/apiRoutes";
import { extraColumnsField } from "utils/helpers";
import { QueryKeys } from "utils/queryKey";
import useDocumentTitle from "utils/useDocumentTitle";
import AddEmployee from "./AddBranchAdmins";

const BranchAdmins = ({ path }: { path?: any }) => {
  useDocumentTitle("Admins");

  const navigate = useNavigate();

  const [addEmployeeModal, setAddEmployeeModal] = useState(false);

  const [selectedId, setSelectedId] = useState(null);

  const requestBody = useGenerateQueryParams("branchAdmin");

  const { data: employeeData, isLoading } = useFetchQuery({
    key: [QueryKeys.EMPLOYEE_LIST, requestBody, path],
    route: path || GET_ALL_EMPLOYEE_LIST,
    requestBody,
  });

  const columns: GridColDef[] = [
    {
      ...extraColumnsField("Name", "name", 250, 1),
      valueGetter: (value) => value?.row?.name || "-",
    },
    {
      ...extraColumnsField("Code", "code", 200, 1),
      valueGetter: (value) => value?.row?.code || "-",
    },
    {
      ...extraColumnsField("Email", "email", 250, 1),
      renderCell: (value) => {
        return (
          <Typography textTransform={"lowercase"}>
            {value?.row?.email || "-"}
          </Typography>
        );
      },
    },
    {
      ...extraColumnsField("Mobile", "phone", 250, 1),
      valueGetter: (value) => value?.row?.phone || "-",
    },
    {
      ...extraColumnsField("Actions", "action", 100, 1),
      align: "right",
      headerAlign: "right",
      renderCell: ({ row }) => {
        return (
          <Box>
            <IconButton
              onClick={(event) => {
                event.stopPropagation();
                setAddEmployeeModal(true);
                setSelectedId(row);
              }}
            >
              <Edit1Icon />
            </IconButton>
            <IconButton
              onClick={(event) => {
                event.stopPropagation();
                navigate(`/app/admin/${row.id}`);
              }}
            >
              <SettingsIcon />
            </IconButton>
          </Box>
        );
      },
    },
  ];

  return (
    <>
      <GKDataGrid
        density="compact"
        rows={employeeData?.data?.data || []}
        columns={columns}
        loading={isLoading}
        maxHeight={"calc(100vh - 312px)"}
        totalCount={employeeData?.data?.totalCount || 0}
        name="branchAdmin"
        headerComponent={
          <GKButton
            variant="contained"
            onClick={() => setAddEmployeeModal(true)}
            startIcon={<PlusIcon />}
          >
            Add Admin
          </GKButton>
        }
        tableName="branch_admin_list"
        exportFile={{
          path: GET_ALL_EMPLOYEE_LIST,
          exportName: "EmployeeList",
        }}
      />

      {addEmployeeModal && (
        <AddEmployee
          open={addEmployeeModal}
          setOpen={setAddEmployeeModal}
          selectedId={selectedId}
          setSelectedId={setSelectedId}
        />
      )}
    </>
  );
};

export default BranchAdmins;
